import { z } from 'zod';
import { InspectionEntityCornSchema, VideoCornSchema } from '../base.js';
export const ShareLinkSchema = z.object({
    dateCreated: z.iso.datetime(),
    entityId: InspectionEntityCornSchema,
    expirationDate: z.iso.datetime(),
    requestActor: z.string(),
    url: z.url(),
    videoId: VideoCornSchema,
});
